import React from 'react';

import { TextField, TextAreaField, MCButton } from 'src/components/basic';
import { MediaDropBox } from 'src/components/complex';
import BaseComponent from 'src/components/BaseComponent';

import { lang, remCss } from 'src/helpers';

const apiId = 'createJourney';

export default class CreateJourney extends BaseComponent {
  componentDidMount() {
    this.getModel().baseSubscribe(this.subscription);
    this.getModel().resetCreateJourney();
  }

  componentWillUnmount() {
    this.getModel().unsubscribe(this.subscription);
  }
  getModel = () => this.props.model;

  submit = (e) => {
    e.preventDefault();
    const { hide } = this.props;
    this.getModel().createJourney((error, data, success) => {
      if (success) hide();
    });
  };

  render() {
    const model = this.getModel();
    const { closeBtn, hide } = this.props;
    const createState = model.getApiState(apiId);
    const { invalid, loading } = createState;

    return (
      <div className='mc-popup-contain' style={{ width: remCss(600) }}>
        <div className='mc-modal-header'>
          <div className='mc-popup-title'>{lang.t('New Diary')}</div>
          {closeBtn}
        </div>
        <form className='mc-modal-body mc-flex-15-col' onSubmit={this.submit}>
          <TextField
            template={5}
            name={'title'}
            label={'Title'}
            placeholder={'enter title'}
            value={model.input('title')}
            onChange={(key, value) => model.handleChange(key, value)}
            onBlur={(key, value) => {
              model.handleBlur(key, value, apiId);
            }}
            invalid={invalid}
          />
          <TextAreaField
            rows={3}
            template={5}
            name={'description'}
            label={'Description'}
            placeholder={'write here'}
            value={model.input('description')}
            onChange={model.handleChange}
            onBlur={(key, value) => {
              model.handleBlur(key, value, apiId);
            }}
            invalid={invalid}
          />
          <div className={'mc-flex-10-col'}>
            <div className={'mc-value-420'}>{lang.t('Icon')}</div>
            <MediaDropBox
              name={'icon'}
              labelIcon='Choose Icon'
              multi={false}
              value={model.input('icon') !== '' ? model.input('icon') : []}
              invalid={invalid}
              onChange={(n, v) => {
                model.resetApiState(apiId);
                model.handleChange(n, v);
              }}
            />
          </div>
          <div className={'mc-flex-10-col'}>
            <div className={'mc-value-420'}>{lang.t('Cover')}</div>
            <MediaDropBox
              name={'files'}
              labelIcon='Add File'
              multi={false}
              value={model.input('files') !== '' ? model.input('files') : []}
              invalid={invalid}
              onChange={(n, v) => {
                model.resetApiState(apiId);
                model.handleChange(n, v);
              }}
            />
          </div>
        </form>
        <div className='mc-modal-footer mc-flex'>
          <div className={'mc-grow'} />
          <MCButton
            medium
            primary
            radius
            light
            disabled={loading}
            type={'button'}
            onClick={hide}
            label={'Cancel'}
          />
          <MCButton
            medium
            primary
            radius
            dark
            disabled={loading}
            type={'submit'}
            onClick={this.submit}
            label={loading ? lang.t('Adding') + '...' : lang.t('Add')}
          />
        </div>
      </div>
    );
  }
}
